import qs from 'qs';
import moment from 'moment';
import api from './api';
import generateSearchRequest from '../utils/sequelize-search-builder-client';

const selectPurchase = (purchase) => {
	return {
		...purchase,
		createdAt: purchase.createdAt ? moment(purchase.createdAt).toDate() : null,
		updatedAt: purchase.updatedAt ? moment(purchase.updatedAt).toDate() : null,
		startingDate: purchase.startingDate ? moment(purchase.startingDate).toDate() : null,
	};
};

const selectPurchases = (purchases) => purchases.map(selectPurchase);

class PurchaseService {
	async getAll({ page = 0, size = 10, order, filters }) {
		const settings = {
			where: {
				id: {
					as: 'id',
					type: 'like',
				},
				clientId: {
					as: 'clientId',
					type: 'equal',
				},
				planId: {
					as: 'planId',
					type: 'equal',
				},
				hash: {
					as: 'hash',
					type: 'like',
				},
				providerKey: {
					as: 'providerKey',
					type: 'like',
				},
				providerName: {
					as: 'providerName',
					type: 'like',
				},
				creditcardToken: {
					as: 'creditcardToken',
					type: 'like',
				},
				status: {
					as: 'status',
					type: 'like',
				},
			},
			order,
		};
		const query = generateSearchRequest(filters, settings);
		return api
			.get(`/purchases`, {
				paramsSerializer: {
					serialize: (params) => qs.stringify(params, { arrayFormat: 'brackets' }),
				},
				params: {
					page,
					size,
					...query,
				},
			})
			.then((response) => response.data)
			.then((data) => ({ ...data, body: selectPurchases(data.body) }))
			.catch((error) => {
				console.log(
					'fail when trying to get purchases in PurchaseService.',
					error.response?.data?.error,
				);
				throw error.response?.data?.error;
			});
	}

	async get(id) {
		return api
			.get(`/purchases/${id}`)
			.then((response) => response.data)
			.then((data) => data.body)
			.then(selectPurchase)
			.catch((error) => {
				console.log(
					`fail when trying to get purchase with id ${id} in PurchaseService.`,
					error.response?.data?.error,
				);
				throw error.response?.data?.error;
			});
	}

	async getStatuses() {
		return api
			.get(`/purchases/statuses`)
			.then((response) => response.data)
			.then((data) => data.body)
			.catch((error) => {
				console.log(
					'fail when trying to get purchase statuses in PurchaseService.',
					error.response?.data?.error,
				);
				throw error.response?.data?.error;
			});
	}

	async getInvoice(id) {
		return api
			.get(`/purchases/${id}/invoice`)
			.then((response) => response.data)
			.then((data) => data.body)
			.catch((error) => {
				console.log(
					`fail when trying to get purchase invoice with id ${id} in PurchaseService.`,
					error.response?.data?.error,
				);
				throw error.response?.data?.error;
			});
	}

	async create(purchaseForm) {
		return api
			.post(`/plans/${purchaseForm.planId}/purchase`, purchaseForm)
			.then((response) => response.data)
			.then((data) => data.body)
			.then(selectPurchase)
			.catch((error) => {
				console.log(
					'fail when trying to create purchase in PurchaseService.',
					error.response?.data?.error,
				);
				throw error.response?.data?.error;
			});
	}

	async getByClientId(clientId, { page = 0, size = 10 }) {
		return api
			.get(`/purchases/client/${clientId}`, {
				params: {
					page,
					size,
				},
			})
			.then((response) => response.data)
			.catch((error) => {
				console.log(
					`fail when trying to get purchase by clientId ${clientId} in PurchaseService.`,
					error.response?.data?.error,
				);
				throw error.response?.data?.error;
			});
	}

}

const purchaseService = new PurchaseService();
export default purchaseService;
